export default __webpack_public_path__ + "static/logo-c5116ad3dc8ff7c290113e36b5e1942c.png";